import axios from "../boot/axios";
import { createStore } from "redux";

let data = {
  loadign: false,
  header: {
    tarefeYaGharadad: true,
    kanoonMatboVakil: 0,
    noeVekalat: 0,
    govahiVekalatTakhasosi: false,
    vekalatPasAzNaghzRay: false,
    mamoryatDakhelOstan: 0,
    mamoryatKharejeelOstan: 0,
  },
  mali: {
    natijeDaavi: 0,
    mizanMahkoomKhaste: 0,
    badvi: true,
    tajdidNazar: false,
    divanAli: false,
    omooriEjraii: false,
    omooriEjraiiValue: 0,
  },
  gheyrMali: {
    noeDaavi: 0,
    hoghooghPaye: 0,
    badvi: true,
    tajdidNazar: false,
    divanAli: false,
    omooriEjraii: false,
    omooriEjraiiValue: 0,
  },
  keyfari: {
    salahiat: 0,
    mojazat: 0,
    tedadJaraemeEzafeh: 0,
    hoghooghPaye: 0,
    faghedDadsara: false,
    dadsara: true,
    badviGhatii: false,
    badvi: false,
    tajdidNazar: false,
    farjamKhahiKeyfari: false,
    farjamKhahiKeyfariValue: 0,
    omoorEjraii: false,
    omoorEjraiiValue: 0,
    gharareGhabeleEterazeDadsara: false,
    gharareGhabeleEterazeDadsaraValue: 0,
    taghazaEadehdadresi: false,
    taghazaEadehdadresiValue: 0,
    madde477: false,
    madde477Value: 0,
  },
  footer: {
    badviCost: 0,
    divanAliCost: 0,
    haghTambMaliati: 0,
    hazinehSafar: 0,
    jameHagholvekalehKol: 0,
    sahmKanoonVokala: 0,
    sahmKarmandanMoaser: 0,
    sahmMarkazMoshaveran: 0,
    sahmNamayandeGhazaii: 0,
    sahmSandoghHemayat: 0,
    tajdidNazarCost: 0,
    dadsaraCost: 0,
    farjamKhahiKeyfariCost: 0,
    omoorEjraiiCost: 0,
    gharareGhabeleEterazeDadsaraCost: 0,
    taghazaEadehDadresiCost: 0,
    taghazaMade477Cost: 0,
  },
  minMax: {
    maxEadehdadresi: 0,
    maxEjra: 0,
    maxEjra2: 0,
    maxFarjamKeyfari: 0,
    maxGharareGHabeleEterazeDadsara: 0,
    maxHagholvekale: 0,
    maxMade477: 0,
    minEadehdadresi: 0,
    minEjra: 0,
    minEjra2: 0,
    minFarjamKeyfari: 0,
    minGharareGHabeleEterazeDadsara: 0,
    minHagholvekale: 0,
    minMade477: 0,
  },
};
function sendData(requestName, data) {
  axios.post(`HaghVekalat/${requestName}`, data).then(({ data }) => {
    store.dispatch({ type: "SET_DATA", data });
  });
}
function getMinMax(data) {
  axios.post("HaghVekalat/MinMax", data).then(({ data }) => {
    store.dispatch({ type: "SET_MIN_MAX_VALUE", data });
  });
}
let reducer = (state = data, action) => {
  switch (action.type) {
    case "SET_HEADER":
      return { ...state, header: action.data };
    case "SET_MALI":
      return { ...state, mali: action.data };
    case "SET_GHEYR_MALI":
      return { ...state, gheyrMali: action.data };
    case "SET_KEYFARI":
      return { ...state, keyfari: action.data };
    case "SET_MINMAX":
      let minMax = {
        noeDava: action.data,
        noeVekalat: state.header.noeVekalat,
        govahiVekalatTakhasosi: state.header.govahiVekalatTakhasosi,
        mizanMahkoomKhaste: 0,
        noeDaavi: 0,
        salahiat: 0,
        mojazat: 0,
      };
      if (action.data === 0) {
        minMax.mizanMahkoomKhaste = state.mali.mizanMahkoomKhaste;
      }
      if (action.data === 1) {
        minMax.noeDaavi = state.gheyrMali.noeDaavi;
      }
      if (action.data === 2) {
        minMax.salahiat = state.keyfari.salahiat;
        minMax.mojazat = state.keyfari.mojazat;
      }
      getMinMax(minMax);
      return { ...state, loadign: true };

    case "SEND_DATA":
      function data(name) {
        if (name === "Mali") {
          return { ...state.header, ...state.mali };
        }
        if (name === "GheyrMali") {
          return { ...state.header, ...state.gheyrMali };
        }
        if (name === "Keyfari") {
          return { ...state.header, ...state.keyfari };
        }
      }
      sendData(action.data, data(action.data));
      return state;
    case "SET_DATA":
      return { ...state, footer: action.data };
    case "SET_MIN_MAX_VALUE":
      return { ...state, minMax: action.data, loadign: false };
    default:
      return state;
  }
};

let store = createStore(reducer);

export default store;
